export default "__VITE_ASSET__DpCg2Ed$__"